import { useQuery } from '@apollo/client'
import { GETCLIENTFEATUREFLAGS } from '../../../../../utils/GraphQLAPI'


const DialInNumber = ({ payload, setPayload, dialInNumbers, setDialInNumbers, selectedLanguage }: any) => {

  const { data: featureFlags } = useQuery(GETCLIENTFEATUREFLAGS)

  console.log(dialInNumbers)
  return (
    <div className='fixed-height-body'>
      <label className='fs-6 fw-semibold lh-23 mb-2'>Select TPV Type</label>
      <div className='w-200px mb-5'>
        <select
          id='TimeconditionCheck'
          aria-label='select brand'
          className='form-select form-select-solid'
          value={payload.tpvType}
          onChange={(e) =>
            setPayload((prev: any) => {
              return { ...prev, tpvType: e.target.value }
            })
          }
        >
          <option key='IVR' value='IVR'>
            IVR
          </option>
          {
            featureFlags?.getClientFeatureFlags?.enableLiveAgent && (
              <>
                <option key='LIVE AGENT' value='LIVE AGENT'>
                  Live Agent
                </option>
                <option key='BOTH' value='BOTH'>
                  Both
                </option>
              </>
            )
          }


        </select>
      </div>
      <div className='d-flex'>
        {
          (payload.tpvType === "BOTH" || payload.tpvType === "IVR") && (
            <div className=' me-3'>
              <label className='fs-6 fw-semibold lh-23 mb-2'>IVR dial in number</label>
              <select
                id='TimeconditionCheck'
                aria-label='select brand'
                className='form-select form-select-solid'
                value={dialInNumbers.dialInNumberIVR}
                disabled={true}
                onChange={(e) =>
                  setDialInNumbers((prev: any) => {
                    return { ...prev, dialInNumberIVR: e.target.value }
                  })
                }
              >
                <option key='value' value=''>
                  Select Dial In Number
                </option>
                <option key="dnj" value={dialInNumbers.dialInNumberIVR}>
                  {`+1-${dialInNumbers.dialInNumberIVR}`}
                </option>
              </select>
            </div>
          )
        }

        {
          (payload.tpvType === "BOTH" || payload.tpvType === "LIVE AGENT") && (
            <>
              {
                selectedLanguage.filter((language: any) => language.label === "English").length > 0 && (<div className='mw-250px'>
                  <label className='fs-6 fw-semibold lh-23 mb-2'>
                    Live agent english dial in number
                  </label>
                  <div className='d-flex'>
                    <input
                      type='text'
                      value='+1'
                      className='form-control form-control-lg form-control-solid'
                      disabled
                      style={{
                        width: '25%',
                        padding: '7px',
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px',
                      }}
                    />
                    <input
                      type='text'
                      id='customerPrimaryPhoneNumber'
                      className='form-control form-control-lg form-control-solid me-3'
                      name='customerPrimaryPhoneNumber'
                      placeholder='Enter Primary number'
                      value={dialInNumbers.dialInNumberLiveAgentEng}
                      disabled={true}
                      //onBlur={(e) => handlePrimaryOnBlur(e)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                      }}
                    />
                  </div>
                </div>)
              }
              {
                selectedLanguage.filter((language: any) => language.label === "Spanish").length > 0 && (<div className='mw-250px'>
                  <label className='fs-6 fw-semibold lh-23 mb-2'>
                    Live agent spanish dial in number
                  </label>
                  <div className='d-flex'>
                    <input
                      type='text'
                      value='+1'
                      className='form-control form-control-lg form-control-solid'
                      disabled
                      style={{
                        width: '25%',
                        padding: '7px',
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px',
                      }}
                    />
                    <input
                      type='text'
                      id='customerPrimaryPhoneNumber'
                      className='form-control form-control-lg form-control-solid me-3'
                      name='customerPrimaryPhoneNumber'
                      placeholder='Enter Primary number'
                      value={dialInNumbers.dialInNumberLiveAgentSpn}
                      disabled={true}
                      //onBlur={(e) => handlePrimaryOnBlur(e)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                      }}
                    />
                  </div>
                </div>)
              }



            </>
          )
        }

      </div>

    </div>
  )
}
export default DialInNumber
